export function collectAmbiguousPartNumbers(
  products: Array<{ partNumber?: string | null }>,
): Set<string> {
  const counts = new Map<string, number>()
  for (const product of products) {
    const partNumber = product.partNumber?.trim()
    if (!partNumber) continue
    counts.set(partNumber, (counts.get(partNumber) ?? 0) + 1)
  }
  return new Set(
    [...counts.entries()].filter(([, count]) => count > 1).map(([partNumber]) => partNumber),
  )
}

/** Prefer partNumber for SEO; fall back to unique sku or MongoDB id when partNumber is duplicated. */
export function getProductDetailSlug(
  product: {
    id: string
    partNumber?: string | null
    sku?: string | null
  },
  options?: { ambiguousPartNumbers?: Set<string> },
): string {
  const partNumber = product.partNumber?.trim()
  const sku = product.sku?.trim()
  const isAmbiguous = partNumber ? options?.ambiguousPartNumbers?.has(partNumber) : false

  if (partNumber && !isAmbiguous) {
    return encodeURIComponent(partNumber)
  }
  if (sku) {
    return encodeURIComponent(sku)
  }
  return product.id
}

export function buildProductDetailUrl(slug: string): string {
  return `/products/${slug}`
}
